import { Link, NavLink } from 'react-router-dom';
import '../assets/css/sidebar.css';
import { sidebarIcons } from '../assets/images/sidebar';

export default function Sidebar() {
  return (
    // <div style={{ display: 'fixed', height: '100vh' }}>
    //   <nav style={{ width: '200px', background: '#f4f4f4', padding: '1rem' }}>
    //     <h2>Menu</h2>
    //     <ul style={{ listStyle: 'none', padding: 0 }}>
    //       <li><Link to="/dashboard/home">Accueil</Link></li>
    //       <li><Link to="/dashboard/settings">Paramètres</Link></li>
    //       <li><Link to="/dashboard/profile">Profil</Link></li>
    //     </ul>
    //   </nav>
    //   <main style={{ flex: 1, padding: '2rem' }}>
    //     <Outlet />
    //   </main>
    // </div>

    <div className="sidebar-menu">
        {/* Profil  */}
        <Link to="/userSettings" className="menu-profile" id="userSettings">
            {/* <?php
                if ($session->get('User_HasCustomPicture')) {
                    echo "<img src='" . base_url('userPicture/' . $session->get('User_CustomPhotoName') . '.png') . "' className='profile-pic' alt='Profile'>";
                } else {
                    echo "<img src='" . base_url('svgIcons/profile-pic-settings.svg') . "' className='profile-pic' alt='Profile'>";
                }
            ?> */}
            <img src={sidebarIcons.profile} className='profile-pic' alt='Profile'/>

            <div className="profile-name">{/*<?php echo $session->get('User_UserName'); ?>*/}Username</div>
        </Link>

        {/* Options du menu */}
        <NavLink 
            to="/themeSelector" 
            className={({ isActive }) => `menu-item ${isActive ? 'active' : ''}`} 
            id="theme"
        >
            <div className="menu-icon">
                <img src={sidebarIcons.games} alt="Jeux" />
                <p>Jeux</p>
            </div>
        </NavLink>

        <NavLink 
            to="/stats" 
            className={({ isActive }) => `menu-item ${isActive ? 'active' : ''}`} 
            id="userStatistics"
        >
            <div className="menu-icon">
                <img src={sidebarIcons.stat} alt="Statistiques" />
                <p>Statistiques</p>
            </div>
        </NavLink>

        <NavLink 
            to="/autoTest" 
            className={({ isActive }) => `menu-item ${isActive ? 'active' : ''}`} 
            id="autoTest"
        >
            <div className="menu-icon">
                <img src={sidebarIcons.autoTest} alt="Auto-test" />
                <p>Auto - test</p>
            </div>
        </NavLink>

        <NavLink 
            to="/eval" 
            className={({ isActive }) => `menu-item ${isActive ? 'active' : ''}`} 
            id="evaluation"
        >
            <div className="menu-icon">
                <img src={sidebarIcons.evalIcon} alt="Évaluation" />
                <p>Évaluation</p>
            </div>
        </NavLink>
    </div>
  );
}